@if (itemsCount() !== null) {
  <div class="content-list-wrapper">
    <div #listElement class="content-list">
      @for (contentList of contentLists(); let isFirst = $first; track contentList) {
        @if (contentList.items()?.length || isFirst) {
          @if (contentList.headerTemplate(); as headerTemplate) {
            <ng-container *ngTemplateOutlet="headerTemplate" />
          }
          @if (itemsCount()) {
            <div
              class="content-list-items"
              [ngClass]="{ 'content-list-loading': loading() }"
              [style.background-color]="contentList.backgroundColor()"
            >
              @if (loading()) {
                <div class="content-list-loader-container">
                  <ex-overlay-loader class="content-list-loader" color="secondary" />
                </div>
              }
              @for (item of contentList.items(); track item) {
                @if (contentList.itemTemplate(); as itemTemplate) {
                  <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }" />
                }
              }
            </div>
          } @else {
            @if (emptyTemplate(); as emptyTemplate) {
              <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
            }
          }
        }
      }
      @if (itemsCount() && footerTemplate(); as footerTemplate) {
        <div class="content-list-footer">
          <ng-container *ngTemplateOutlet="footerTemplate" />
        </div>
      }
    </div>
  </div>
} @else {
  @if (loading() && loadingTemplate(); as loadingTemplate) {
    <ng-container *ngTemplateOutlet="loadingTemplate" />
  } @else {
    @if (placeholderTemplate(); as placeholderTemplate) {
      <ng-container *ngTemplateOutlet="placeholderTemplate"></ng-container>
    }
  }
}
